// #viet_code
import React, {useState, useEffect} from 'react';
import Pagination from 'react-js-pagination';
import {useSelector} from 'react-redux';
import {NavLink, useHistory} from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import {Badge, Form} from 'react-bootstrap';
import {toast} from 'react-toastify';
import {useMutation, useQuery} from 'react-query';
import {MAINTENANCE_BATCH_API} from '@app/utils/apiUrl.js';
import {DeleteSingle, Get, Put} from '@app/utils/httpProvider';
import {createUrlWithParam, formatDateTimeMoment} from '../../utils/helper';
import {URI_INTERNAL} from '../../utils/pathLocations';
import {objectShowNumber, messageToast} from '../../utils/define';
import {ConfirmModal} from '../../modules/modal/ConfirmModal';
import ReactToPrint from 'react-to-print';
import MaintenanceBatchPrintTemplate from './MaintenanceBatchPrintTemplate';
import {useRef} from 'react';
import {getRoleUser} from '@app/utils/httpClient';
const statusStyles = {
    'Đã hoàn thành': {
        background: '#10b981',
        color: '#ffffff',
        icon: 'fa-check-circle'
    },
    'Chờ phê duyệt': {
        background: '#ffc107',
        color: '#000000',
        icon: 'fa-clock'
    },
    'Đang xử lý': {
        background: '#3b82f6',
        color: '#ffffff',
        icon: 'fa-wrench'
    },
    'Không phê duyệt': {
        background: '#ef4444',
        color: '#ffffff',
        icon: 'fa-times-circle'
    }
};

const StatusBadge = ({status, isOverdue}) => {
    const displayStatus = status === 'Đang xử lý' ? 'Đang sửa chữa' : status;
    const getStyle = (statusName) => {
        if (!statusName)
            return {
                background: '#6b7280',
                color: '#ffffff',
                icon: 'fa-info-circle'
            };

        const lower = statusName.toLowerCase();
        if (lower === 'đã hoàn thành') return statusStyles['Đã hoàn thành'];
        if (lower === 'chờ phê duyệt') return statusStyles['Chờ phê duyệt'];
        if (lower === 'đang xử lý' || lower === 'đang sửa chữa')
            return statusStyles['Đang xử lý'];
        if (lower === 'không phê duyệt') return statusStyles['Không phê duyệt'];

        return {
            background: '#6b7280',
            color: '#ffffff',
            icon: 'fa-info-circle'
        };
    };

    const style = getStyle(status);

    return (
        <div className="position-relative d-inline-flex align-items-center justify-content-center">
            {isOverdue && (
                <i
                    className="fas fa-exclamation-triangle text-danger position-absolute"
                    style={{
                        left: '-28px',
                        fontSize: '20px',
                        animation: 'pulseAlert 1s infinite'
                    }}
                    title="Quá hạn"
                />
            )}
            <span
                className="badge shadow-sm d-inline-flex align-items-center justify-content-center"
                style={{
                    padding: '4px 10px',
                    borderRadius: '6px',
                    fontSize: '11px',
                    fontWeight: 700,
                    background: style.background,
                    color: style.color,
                    whiteSpace: 'nowrap',
                    textTransform: 'uppercase',
                    minWidth: '135px',
                    height: '24px',
                    letterSpacing: '0.3px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
            >
                <i
                    className={`fas ${style.icon} mr-1`}
                    style={{fontSize: '10px'}}
                />
                {displayStatus}
            </span>
        </div>
    );
};

const GlobalStyles = () => (
    <style>
        {`
            @keyframes pulseAlert {
                0% { transform: scale(1); opacity: 1; }
                50% { transform: scale(1.3); opacity: 0.7; }
                100% { transform: scale(1); opacity: 1; }
            }
            @keyframes shakeAlert {
                0% { transform: translateX(0); }
                25% { transform: translateX(-2px); }
                50% { transform: translateX(2px); }
                75% { transform: translateX(-2px); }
                100% { transform: translateX(0); }
            }
        `}
    </style>
);

const MaintenanceBatchList = () => {
    const history = useHistory();
    const contextSearch = useSelector((state) => state.search.valueSearch);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [statusFilter, setStatusFilter] = useState('');
    // Role simulation
    const [userRole, setUserRole] = useState('');
    const isAdmin = Array.isArray(userRole)
        ? userRole.some((r) => r.toLowerCase() === 'admin')
        : typeof userRole === 'string' && userRole.toLowerCase() === 'admin';

    // Quản lý việc huỷ & ẩn phiếu (Soft Delete)
    const [openConfirmCancelModal, setOpenConfirmCancelModal] = useState(false);
    const [idWantCancel, setIdWantCancel] = useState('');
    const [confirmCancelMessage, setConfirmCancelMessage] = useState('');
    const [confirmType, setConfirmType] = useState('delete'); // 'cancel' or 'hard-delete'

    const cancelFunc = useMutation((id) =>
        Put(`${MAINTENANCE_BATCH_API.CANCEL}/${id}`, null, null, false)
    );

    const approveFunc = useMutation((id) =>
        Put(`${MAINTENANCE_BATCH_API.APPROVE}/${id}`, null, null, false)
    );

    const rejectFunc = useMutation((id) =>
        Put(`${MAINTENANCE_BATCH_API.REJECT}/${id}`, null, null, false)
    );

    const deleteFunc = useMutation((id) =>
        DeleteSingle(`${MAINTENANCE_BATCH_API.DELETE}/${id}`)
    );

    const completeFunc = useMutation((id) =>
        Put(
            `https://localhost:5001/api/v1/MaintenanceBatch/Complete/${id}`,
            null,
            null,
            false
        )
    );

    const unapproveFunc = useMutation((id) =>
        Put(`${MAINTENANCE_BATCH_API.UNAPPROVE}/${id}`, null, null, false)
    );

    const {isLoading, isError, error, data, refetch} = useQuery(
        ['maintenanceBatchData', contextSearch, page, pageSize, statusFilter],
        () => {
            const model = {
                SearchText: contextSearch || '',
                PageIndex: page,
                PageSize: pageSize
            };
            if (statusFilter) {
                model.Status = statusFilter;
            }
            return Get(MAINTENANCE_BATCH_API.GET_PAGING, null, model);
        }
    );
    useEffect(() => {
        const fetchRole = async () => {
            const role = await getRoleUser();
            setUserRole(typeof role === 'string' ? role.toLowerCase() : role);
        };
        fetchRole();
    }, []);

    useEffect(() => {
        refetch();
    }, [pageSize, page, contextSearch, statusFilter, refetch]);

    const changePage = (number) => {
        setPage(number);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(e.target.value);
        setPage(1);
    };

    const cancelAction = (id, code, type = 'cancel') => {
        setIdWantCancel(id);
        setConfirmCancelMessage(code);
        setConfirmType(type);
        setOpenConfirmCancelModal(true);
    };

    const approveAction = (id, code) => {
        setIdWantCancel(id);
        setConfirmCancelMessage(code);
        setConfirmType('approve');
        setOpenConfirmCancelModal(true);
    };

    const rejectAction = (id, code) => {
        setIdWantCancel(id);
        setConfirmCancelMessage(code);
        setConfirmType('reject');
        setOpenConfirmCancelModal(true);
    };

    const completeAction = (id, code) => {
        setIdWantCancel(id);
        setConfirmCancelMessage(code);
        setConfirmType('complete');
        setOpenConfirmCancelModal(true);
    };

    const unapproveAction = (id, code) => {
        setIdWantCancel(id);
        setConfirmCancelMessage(code);
        setConfirmType('unapprove');
        setOpenConfirmCancelModal(true);
    };

    const acceptCancel = async () => {
        if (idWantCancel !== '') {
            if (confirmType === 'cancel') {
                cancelFunc.mutate(idWantCancel, {
                    onSuccess: () => {
                        toast.success('Đã huỷ và gỡ bỏ phiếu thành công!');
                        refetch();
                        setOpenConfirmCancelModal(false);
                    },
                    onError: () =>
                        toast.error(
                            'Không thể thực hiện thao tác. Vui lòng thử lại!'
                        )
                });
            } else if (confirmType === 'approve') {
                approveFunc.mutate(idWantCancel, {
                    onSuccess: () => {
                        toast.success(
                            'Đã phê duyệt toàn bộ thiết bị trong phiếu thành công!'
                        );
                        refetch();
                        setOpenConfirmCancelModal(false);
                    },
                    onError: (err) =>
                        toast.error(
                            err?.message ||
                                'Có lỗi khi phê duyệt. Vui lòng thử lại!'
                        )
                });
            } else if (confirmType === 'reject') {
                rejectFunc.mutate(idWantCancel, {
                    onSuccess: () => {
                        toast.success('Đã từ chối phiếu sửa chữa thành công!');
                        refetch();
                        setOpenConfirmCancelModal(false);
                    },
                    onError: (err) =>
                        toast.error(
                            err?.message ||
                                'Có lỗi khi từ chối. Vui lòng thử lại!'
                        )
                });
            } else if (confirmType === 'complete') {
                completeFunc.mutate(idWantCancel, {
                    onSuccess: () => {
                        toast.success(
                            'Đã hoàn thành phiếu sửa chữa thành công!'
                        );
                        refetch();
                        setOpenConfirmCancelModal(false);
                    },
                    onError: (err) =>
                        toast.error(
                            err?.message ||
                                'Có lỗi khi hoàn thành. Vui lòng thử lại!'
                        )
                });
            } else if (confirmType === 'unapprove') {
                unapproveFunc.mutate(idWantCancel, {
                    onSuccess: () => {
                        toast.success('Đã bỏ phê duyệt phiếu thành công!');
                        refetch();
                        setOpenConfirmCancelModal(false);
                    },
                    onError: (err) =>
                        toast.error(
                            err?.message ||
                                'Có lỗi khi bỏ phê duyệt. Vui lòng thử lại!'
                        )
                });
            } else {
                deleteFunc.mutate(idWantCancel, {
                    onSuccess: () => {
                        toast.success(
                            'Đã xoá vĩnh viễn phiếu sửa chữa thành công!'
                        );
                        refetch();
                        setOpenConfirmCancelModal(false);
                    },
                    onError: (err) =>
                        toast.error(
                            err?.message ||
                                'Không thể xoá phiếu. Vui lòng thử lại!'
                        )
                });
            }
        }
    };

    return (
        <div className="container-fluid">
            <GlobalStyles />
            <div className="row">
                <div className="col-lg-12">
                    <div className="card shadow-sm">
                        <div className="card-header bg-white d-flex justify-content-between align-items-center py-3">
                            <h5 className="card-title fw-bold text-primary mb-0">
                                <i className="fas fa-file-invoice mr-2" />
                                Danh sách Phiếu Sửa chữa
                            </h5>
                            <div className="ml-auto d-flex align-items-center">
                                <NavLink
                                    to={
                                        URI_INTERNAL.MAINTENANCE_BATCH_CREATE_PATH
                                    }
                                >
                                    <button
                                        type="button"
                                        className="btn btn-info btn-sm shadow-sm"
                                    >
                                        <i className="fas fa-plus mr-1" /> Thêm
                                        phiếu sửa chữa mới
                                    </button>
                                </NavLink>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="d-flex align-items-center mb-3">
                                <form className="form-inline">
                                    <label className="mr-2">Hiển thị :</label>
                                    <select
                                        className="form-control form-control-sm"
                                        value={pageSize}
                                        onChange={onChangeShowNumber}
                                        style={{width: '80px'}}
                                    >
                                        {objectShowNumber.map((item, key) => (
                                            <option
                                                key={key}
                                                value={item.value}
                                            >
                                                {item.text}
                                            </option>
                                        ))}
                                    </select>
                                </form>

                                <div className="ml-4 pl-4 border-left d-flex align-items-center">
                                    <span className="mr-2 fw-bold text-secondary">
                                        Trạng thái :
                                    </span>
                                    <select
                                        className="form-control form-control-sm"
                                        value={statusFilter}
                                        onChange={(e) => {
                                            setStatusFilter(e.target.value);
                                            setPage(1);
                                        }}
                                        style={{
                                            width: '160px',
                                            borderRadius: '8px',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        <option value="">-- Tất cả --</option>
                                        <option value="Quá hạn">
                                            {' '}
                                            Quá hạn{' '}
                                        </option>
                                        <option value="Chờ phê duyệt">
                                            Chờ phê duyệt
                                        </option>
                                        <option value="Đang sửa chữa">
                                            Đang sửa chữa
                                        </option>
                                        <option value="Đã hoàn thành">
                                            Đã hoàn thành
                                        </option>
                                        <option value="Không phê duyệt">
                                            Không phê duyệt
                                        </option>
                                    </select>
                                </div>
                            </div>

                            {isLoading ? (
                                <div className="text-center p-5">
                                    Đang tải...
                                </div>
                            ) : isError ? (
                                <div className="alert alert-danger">
                                    Có lỗi xảy ra: {error?.message}
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <Table
                                        striped
                                        bordered
                                        hover
                                        size="sm"
                                        className="mb-0"
                                    >
                                        <thead>
                                            <tr
                                                className="text-dark fw-bold text-uppercase"
                                                style={{fontSize: '13px'}}
                                            >
                                                <th
                                                    className="text-center py-2"
                                                    style={{width: '60px'}}
                                                >
                                                    STT
                                                </th>
                                                <th className="py-2">
                                                    Mã phiếu
                                                </th>
                                                <th className="py-2">
                                                    Tiêu đề - Nội dung
                                                </th>
                                                <th
                                                    className="text-center py-2"
                                                    style={{width: '120px'}}
                                                >
                                                    Số thiết bị
                                                </th>
                                                <th
                                                    className="text-center py-2"
                                                    style={{width: '180px'}}
                                                >
                                                    Hạn hoàn thành
                                                </th>
                                                <th className="py-2">
                                                    Người thực hiện
                                                </th>
                                                <th className="text-center py-2">
                                                    Trạng thái
                                                </th>
                                                <th
                                                    className="text-center py-2"
                                                    style={{width: '120px'}}
                                                >
                                                    Thao tác
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.data?.length > 0 ? (
                                                data.data.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td className="text-center align-middle py-2 font-weight-light">
                                                            {index +
                                                                1 +
                                                                (page - 1) *
                                                                    pageSize}
                                                        </td>
                                                        <td className="align-middle py-2">
                                                            <span
                                                                className="fw-bold text-primary"
                                                                style={{
                                                                    cursor: 'pointer'
                                                                }}
                                                                onClick={() =>
                                                                    history.push(
                                                                        URI_INTERNAL.MAINTENANCE_BATCH_DETAIL_PATH.replace(
                                                                            ':id',
                                                                            item.id
                                                                        )
                                                                    )
                                                                }
                                                            >
                                                                {item.batchCode}
                                                            </span>
                                                        </td>
                                                        <td className="align-middle py-2 text-dark">
                                                            {item.title || '—'}
                                                        </td>
                                                        <td className="text-center align-middle py-2">
                                                            <span
                                                                className="badge badge-light border border-info text-info px-2 py-1"
                                                                style={{
                                                                    borderRadius:
                                                                        '12px',
                                                                    fontSize:
                                                                        '11px'
                                                                }}
                                                            >
                                                                {item
                                                                    .maintenanceEvents
                                                                    ?.length ||
                                                                    0}{' '}
                                                                thiết bị
                                                            </span>
                                                        </td>
                                                        {(() => {
                                                            const evts =
                                                                item.maintenanceEvents ||
                                                                [];
                                                            const endDates =
                                                                evts
                                                                    .map(
                                                                        (e) =>
                                                                            e.endDate
                                                                    )
                                                                    .filter(
                                                                        (d) => d
                                                                    )
                                                                    .map((d) =>
                                                                        new Date(
                                                                            d
                                                                        ).getTime()
                                                                    );

                                                            if (
                                                                endDates.length ===
                                                                0
                                                            )
                                                                return (
                                                                    <td className="text-center align-middle py-2 small fw-bold">
                                                                        —
                                                                    </td>
                                                                );

                                                            const maxDateVal =
                                                                Math.max(
                                                                    ...endDates
                                                                );
                                                            const maxDate =
                                                                new Date(
                                                                    maxDateVal
                                                                );
                                                            const isOverdue =
                                                                maxDateVal <
                                                                    new Date().getTime() &&
                                                                item.status !==
                                                                    'Đã hoàn thành' &&
                                                                item.status !==
                                                                    'Không phê duyệt';

                                                            return (
                                                                <td
                                                                    className={`text-center align-middle py-2 small fw-bold ${
                                                                        isOverdue
                                                                            ? 'text-danger'
                                                                            : ''
                                                                    }`}
                                                                    style={
                                                                        isOverdue
                                                                            ? {
                                                                                  animation:
                                                                                      'shakeAlert 0.5s infinite'
                                                                              }
                                                                            : {}
                                                                    }
                                                                >
                                                                    {formatDateTimeMoment(
                                                                        maxDate
                                                                    )}
                                                                </td>
                                                            );
                                                        })()}
                                                        <td className="align-middle py-2 small fw-bold text-dark">
                                                            {item.performedBy}
                                                        </td>
                                                        <td className="text-center align-middle py-2">
                                                            {(() => {
                                                                const evts =
                                                                    item.maintenanceEvents ||
                                                                    [];
                                                                const isOverdue =
                                                                    evts.some(
                                                                        (e) =>
                                                                            e.endDate &&
                                                                            new Date(
                                                                                e.endDate
                                                                            ) <
                                                                                new Date() &&
                                                                            e.status !==
                                                                                'Đã hoàn thành' &&
                                                                            e.status !==
                                                                                'Không phê duyệt' &&
                                                                            e.status !==
                                                                                'Đã huỷ'
                                                                    );

                                                                if (
                                                                    item.status ===
                                                                    'Chờ phê duyệt'
                                                                ) {
                                                                    return (
                                                                        <StatusBadge
                                                                            status="Chờ phê duyệt"
                                                                            isOverdue={
                                                                                isOverdue
                                                                            }
                                                                        />
                                                                    );
                                                                }

                                                                if (
                                                                    evts.length ===
                                                                    0
                                                                )
                                                                    return (
                                                                        <StatusBadge
                                                                            status={
                                                                                item.status
                                                                            }
                                                                        />
                                                                    );

                                                                const allRejected =
                                                                    evts.every(
                                                                        (e) =>
                                                                            e.status ===
                                                                                'Không phê duyệt' ||
                                                                            e.status ===
                                                                                'Đã huỷ'
                                                                    );
                                                                const allFinished =
                                                                    evts.every(
                                                                        (e) =>
                                                                            e.status ===
                                                                                'Đã sửa chữa' ||
                                                                            e.status ===
                                                                                'Không phê duyệt' ||
                                                                            e.status ===
                                                                                'Đã huỷ'
                                                                    );

                                                                let displayStatus =
                                                                    item.status ||
                                                                    'Đang sửa chữa';
                                                                let finalOverdue =
                                                                    isOverdue;

                                                                if (
                                                                    allRejected
                                                                ) {
                                                                    displayStatus =
                                                                        'Không phê duyệt';
                                                                    finalOverdue = false;
                                                                } else if (
                                                                    allFinished
                                                                ) {
                                                                    displayStatus =
                                                                        'Đã hoàn thành';
                                                                    finalOverdue = false;
                                                                }

                                                                return (
                                                                    <StatusBadge
                                                                        status={
                                                                            displayStatus
                                                                        }
                                                                        isOverdue={
                                                                            finalOverdue
                                                                        }
                                                                    />
                                                                );
                                                            })()}
                                                        </td>
                                                        <td className="text-center align-middle py-2">
                                                            <div className="d-flex justify-content-center align-items-center gap-1">
                                                                <NavLink
                                                                    to={URI_INTERNAL.MAINTENANCE_BATCH_DETAIL_PATH.replace(
                                                                        ':id',
                                                                        item.id
                                                                    )}
                                                                    className="btn btn-xs btn-outline-primary mr-1"
                                                                    title="Xem chi tiết"
                                                                    style={{
                                                                        width: '28px',
                                                                        height: '28px',
                                                                        padding:
                                                                            '0',
                                                                        display:
                                                                            'inline-flex',
                                                                        alignItems:
                                                                            'center',
                                                                        justifyContent:
                                                                            'center'
                                                                    }}
                                                                >
                                                                    <i
                                                                        className="fas fa-eye"
                                                                        style={{
                                                                            fontSize:
                                                                                '13px'
                                                                        }}
                                                                    />
                                                                </NavLink>

                                                                <PrintAction
                                                                    item={item}
                                                                />

                                                                {isAdmin &&
                                                                    item.status ===
                                                                        'Chờ phê duyệt' && (
                                                                        <>
                                                                            <button
                                                                                onClick={() =>
                                                                                    approveAction(
                                                                                        item.id,
                                                                                        item.batchCode
                                                                                    )
                                                                                }
                                                                                className="btn btn-xs btn-outline-success mr-1"
                                                                                title="Phê duyệt toàn bộ phiếu"
                                                                                style={{
                                                                                    width: '28px',
                                                                                    height: '28px',
                                                                                    padding:
                                                                                        '0',
                                                                                    display:
                                                                                        'inline-flex',
                                                                                    alignItems:
                                                                                        'center',
                                                                                    justifyContent:
                                                                                        'center'
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    className="fas fa-check"
                                                                                    style={{
                                                                                        fontSize:
                                                                                            '13px'
                                                                                    }}
                                                                                />
                                                                            </button>
                                                                            <button
                                                                                onClick={() =>
                                                                                    rejectAction(
                                                                                        item.id,
                                                                                        item.batchCode
                                                                                    )
                                                                                }
                                                                                className="btn btn-xs btn-outline-danger mr-1"
                                                                                title="Từ chối phiếu"
                                                                                style={{
                                                                                    width: '28px',
                                                                                    height: '28px',
                                                                                    padding:
                                                                                        '0',
                                                                                    display:
                                                                                        'inline-flex',
                                                                                    alignItems:
                                                                                        'center',
                                                                                    justifyContent:
                                                                                        'center'
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    className="fas fa-times"
                                                                                    style={{
                                                                                        fontSize:
                                                                                            '13px'
                                                                                    }}
                                                                                />
                                                                            </button>
                                                                        </>
                                                                    )}

                                                                {/* Nút hoàn thành nhanh đã bị gỡ bỏ để bắt buộc người dùng vào chi tiết xử lý từng thiết bị */}

                                                                 {isAdmin &&
                                                                     item.status ===
                                                                         'Đang sửa chữa' && (
                                                                         <button
                                                                             onClick={() =>
                                                                                 unapproveAction(
                                                                                     item.id,
                                                                                     item.batchCode
                                                                                 )
                                                                             }
                                                                             className="btn btn-xs btn-outline-warning mr-1"
                                                                             title="Bỏ phê duyệt phiếu"
                                                                             style={{
                                                                                 width: '28px',
                                                                                 height: '28px',
                                                                                 padding:
                                                                                     '0',
                                                                                 display:
                                                                                     'inline-flex',
                                                                                 alignItems:
                                                                                     'center',
                                                                                 justifyContent:
                                                                                     'center'
                                                                             }}
                                                                         >
                                                                             <i
                                                                                 className="fas fa-undo"
                                                                                 style={{
                                                                                     fontSize:
                                                                                         '13px'
                                                                                 }}
                                                                             />
                                                                         </button>
                                                                     )}
                                                                 {isAdmin && (

                                                                    <button
                                                                        onClick={() =>
                                                                            cancelAction(
                                                                                item.id,
                                                                                item.batchCode,
                                                                                'cancel'
                                                                            )
                                                                        }
                                                                        className="btn btn-xs btn-outline-danger"
                                                                        title="Xoá phiếu (Xoá mềm)"
                                                                        style={{
                                                                            width: '28px',
                                                                            height: '28px',
                                                                            padding:
                                                                                '0',
                                                                            display:
                                                                                'inline-flex',
                                                                            alignItems:
                                                                                'center',
                                                                            justifyContent:
                                                                                'center'
                                                                        }}
                                                                    >
                                                                        <i
                                                                            className="fas fa-trash-alt"
                                                                            style={{
                                                                                fontSize:
                                                                                    '13px'
                                                                            }}
                                                                        />
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td
                                                        colSpan="8"
                                                        className="text-center p-4"
                                                    >
                                                        Không có dữ liệu hiển
                                                        thị
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            )}

                            <div className="d-flex justify-content-center mt-3">
                                <Pagination
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    innerClass="pagination pagination-sm"
                                    activePage={page}
                                    itemsCountPerPage={Number(pageSize)}
                                    totalItemsCount={data?.totalRecords || 0}
                                    pageRangeDisplayed={5}
                                    onChange={changePage}
                                />
                            </div>

                            <ConfirmModal
                                isOpen={openConfirmCancelModal}
                                confirmType={
                                    [
                                        'approve',
                                        'reject',
                                        'complete',
                                        'cancel',
                                        'delete',
                                        'unapprove'
                                    ].includes(confirmType)
                                        ? 'info'
                                        : 'delete'
                                }
                                acceptText={
                                    confirmType === 'approve'
                                        ? 'Duyệt'
                                        : confirmType === 'reject'
                                        ? 'Từ chối'
                                        : confirmType === 'complete'
                                        ? 'Hoàn thành'
                                        : confirmType === 'cancel'
                                        ? 'Huỷ phiếu'
                                        : confirmType === 'unapprove'
                                        ? 'Bỏ duyệt'
                                        : 'Xoá'
                                }
                                variant={
                                    confirmType === 'approve'
                                        ? 'success'
                                        : confirmType === 'reject'
                                        ? 'danger'
                                        : confirmType === 'complete'
                                        ? 'success'
                                        : 'danger'
                                }
                                handleAccept={acceptCancel}
                                handleCancel={() =>
                                    setOpenConfirmCancelModal(false)
                                }
                                content={
                                    confirmType === 'approve'
                                        ? `Bạn có chắc chắn muốn <b>PHÊ DUYỆT</b> toàn bộ thiết bị trong phiếu [${confirmCancelMessage}] này không?`
                                        : confirmType === 'reject'
                                        ? `Bạn có chắc chắn muốn <b>TỪ CHỐI</b> phiếu sửa chữa [${confirmCancelMessage}] này không?`
                                        : confirmType === 'complete'
                                        ? `Bạn có chắc chắn muốn <b>HOÀN THÀNH</b> phiếu sửa chữa [${confirmCancelMessage}] này không?`
                                        : confirmType === 'cancel'
                                        ? `Bạn có chắc chắn muốn <b>HUỶ</b> và ẩn phiếu sửa chữa [${confirmCancelMessage}] này không?`
                                        : confirmType === 'unapprove'
                                        ? `Bạn có chắc chắn muốn <b>BỎ PHÊ DUYỆT</b> phiếu [${confirmCancelMessage}] này không? Phiếu và tài sản sẽ quay về trạng thái chờ duyệt.`
                                        : `Bạn có chắc chắn muốn <b>XOÁ HOÀN TOÀN</b> phiếu sửa chữa [${confirmCancelMessage}] khỏi hệ thống không?`
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const PrintAction = ({item}) => {
    const componentRef = useRef();
    return (
        <>
            <div style={{display: 'none'}}>
                <MaintenanceBatchPrintTemplate ref={componentRef} data={item} />
            </div>
            <ReactToPrint
                trigger={() => (
                    <button
                        type="button"
                        className="btn btn-xs btn-outline-secondary mr-1"
                        title="In phiếu sửa chữa"
                        style={{
                            width: '28px',
                            height: '28px',
                            padding: '0',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <i
                            className="fas fa-print"
                            style={{fontSize: '13px'}}
                        />
                    </button>
                )}
                content={() => componentRef.current}
                pageStyle="@page { size: A4 portrait; margin: 0; } @media print { body { -webkit-print-color-adjust: exact; padding: 10mm !important; } }"
            />
        </>
    );
};

export default MaintenanceBatchList;
